import * as Style from "../style/StyledComponents";
import Navbar from "./Navbar";
import {Mint} from "./Mint";
import { abbreviateAddress, chain, links, data, getEtherscanTxnLink } from "./Config";

import { useEffect, useRef } from "react";


import { FaTwitter, FaDiscord, FaFilePdf, FaGlobe  } from "react-icons/fa";
import styled, { keyframes }  from 'styled-components';
import { useState } from "react";
import { useAccount, useDisconnect } from 'wagmi'

import imgHero from "../images/derplets.png";
import imgSingle from "../images/smoker.png";
import imgChart from "../images/chart.png";

import sfxToot from "../audio/toot.wav";

import imgCritter1 from "../images/derplets/1.png";
import imgCritter2 from "../images/derplets/2.png";
import imgCritter3 from "../images/derplets/3.png";
import imgCritter4 from "../images/derplets/4.png";
import imgCritter5 from "../images/derplets/5.png";
import imgCritter6 from "../images/derplets/6.png";
import imgCritter7 from "../images/derplets/7.png";
import imgCritter8 from "../images/derplets/8.png";
import imgCritter9 from "../images/derplets/9.png";
import imgCritter10 from "../images/derplets/10.png";
import imgCritter11 from "../images/derplets/11.png";
import imgCritter12 from "../images/derplets/12.png";
import imgCritter13 from "../images/derplets/13.png";
import imgCritter14 from "../images/derplets/14.png";
import imgCritter15 from "../images/derplets/15.png";
import imgCritter16 from "../images/derplets/16.png";
import { containsAddressInList } from "../merkle/merkle";

const FolderHeader = styled.nav`
	margin-top: 1.5em;
	padding-bottom: 0.2em;
`;

const FolderContent = styled.nav`
	padding: 1em 0em 2em 0em;
	font-size: 1em;
	text-align: left;
`;

const FolderTab = styled.span`
	font-family: "Header";
	font-weight: bold;
	
	border-top: 1px solid var(--text);
	border-left: 1px solid var(--text);
	border-right: 3px solid var(--text);
	border-radius: 7px 7px 0 0;

	padding:0.0em 1em;

	box-sizing: border-box;
	position: relative;
	top: 1px;
	margin: 0 0.4em;

	color: var(--link);
	cursor: pointer;
	user-select: none;

	background-color: #36cf81;

	&:hover {
		background-color: white;
		color: var(--text);
	}

	${props => props.active == "true" && `
		border-bottom: 1px solid var(--background);
		background-color: var(--background);
		color: var(--text);
		cursor: default;
		user-select: none;

		&:hover {
			background-color: var(--background);
		}
	`}
`;

const StyledTable = styled.table`
	width: 100%;
	border-collapse: collapse;
`;

const StyledRow = styled.tr`
	border-bottom: 1px solid #35CB7F;
`;

const StyledTitle = styled.td`
	text-align: left;
	font-weight: bold;
`;

const StyledValue = styled.td`
	text-align: right;
	padding: 0.05em 0;
`;

const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
`;



const AnimatedImage = styled.img`
  width: 100%;
  height: auto;
  cursor: pointer;

  user-select: none; // Prevents text selection
  -webkit-user-select: none; // Prevents text selection in WebKit browsers
  -moz-user-select: none; // Prevents text selection in Mozilla browsers
  -ms-user-select: none; // Prevents text selection in Internet Explorer/Edge
  -o-user-select: none; // Prevents text selection in Opera browsers
  -webkit-touch-callout: none; // Prevents callout menu on iOS

  -webkit-user-drag: none; // Disables dragging in WebKit browsers
  -khtml-user-drag: none; // Disables dragging in KHTML browsers
  -moz-user-drag: none; // Disables dragging in Mozilla browsers
  -o-user-drag: none; // Disables dragging in Opera browsers
  user-drag: none; // Disables dragging in standard browsers
  
  /*
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  image-rendering: pixelated;
  */
`;

function randomBetween(minVal, maxVal) {
  return Math.random() * (maxVal - minVal) + minVal;
}

 // Start of Selection

const AnimatedImageComponent = ({ src, alt, playNote }) => {
  const imgRef = useRef(null);

  const randomTimeOffset = Number(alt) * 3333.0;
  const clickSquishAmount = useRef(0);

  useEffect(() => {
    let frameId;
    let lastFrameTime = Date.now();

    const animate = () => {
      if (imgRef.current) {
        const speed = 1 / 250;
        const squishXAmount = 0.04;
        const squishYAmount = 0.04;

        const clickSquishSpeed = 5.5;
        const clickSquishAmplitude = 0.3;

        const currentTime = Date.now();
        const deltaTime = (currentTime - lastFrameTime) / 1000; // Convert to seconds
        lastFrameTime = currentTime;

        const squishX =
          1 +
          squishXAmount * Math.sin((currentTime + randomTimeOffset) * speed) +
          clickSquishAmount.current * clickSquishAmplitude;
        const squishY =
          1 +
          squishYAmount * Math.cos((currentTime + randomTimeOffset) * speed) -
          clickSquishAmount.current * clickSquishAmplitude;
        imgRef.current.style.transform = `translateY(25%) scale(${squishX}, ${squishY}) translateY(-25%)`;

        clickSquishAmount.current = Math.max(
          0,
          clickSquishAmount.current - clickSquishSpeed * deltaTime
        );
      }
      frameId = requestAnimationFrame(animate);
    };
    animate();
    return () => cancelAnimationFrame(frameId);
  }, []);

  const handleClick = () => {
    clickSquishAmount.current = 1.0;
    playNote();
  };

  const handleMouseOver = () => {
    clickSquishAmount.current = 0.5;
  };

  return <AnimatedImage ref={imgRef} src={src} alt={alt} onClick={handleClick} onMouseOver={handleMouseOver} />;
};

function ImageGridComponent() {
  /*const songNotes = [
    64, 64, 66, 64, 69, 68, 64, 64, 66, 64, 71, 69, 64, 64, 76, 72, 69, 68, 66,
    74, 74, 73, 71, 69, 71, 69, 64, 64, 66, 64, 69, 68, 64, 64, 66, 64, 71, 69,
    64, 64, 76, 72, 69, 68, 66
  ];*/

  const twinkleTwinkleNotes = [
    66, 66, 73, 73, 75, 75, 73, 71, 71, 70, 70, 68, 68, 66, // First phrase
    73, 73, 71, 71, 70, 70, 68, // Second phrase
    73, 73, 71, 71, 70, 70, 68, // Repeat second phrase
    66, 66, 73, 73, 75, 75, 73, 71, 71, 70, 70, 68, 68, 66  // Repeat first phrase
  ];


  const superMarioThemeNotes = [
    76, 76, 76, 72, 76, 79, 67, // First phrase
    72, 67, 64, 69, 71, 70, 69, // Second phrase
    67, 76, 79, 81, 77, 79, 76, 72, 74, 71, // Third phrase
    72, 67, 64, 69, 71, 70, 69, // Fourth phrase
  ];

  const happyBirthdayNotes = [
    64, 64, 66, 64, 69, 68, // "If you're happy and you know it"
    64, 64, 66, 64, 71, 69, // "Clap your hands"
    64, 64, 76, 72, 69, 68, 66, // "If you're happy and you know it"
    74, 74, 73, 71, 69, 71, 69 // "Clap your hands"
  ];

  const oldMacdonaldNotes = [
  64, 64, 64, 71, 73, 73, 71, // Verse
  68, 68, 66, 66, 64, // Verse continuation
  64, 64, 64, 71, 73, 73, 71, // Verse
  68, 68, 66, 66, 64, // Verse continuation

  ];


  const songNotes = oldMacdonaldNotes;

  const [currentNoteIndex, setCurrentNoteIndex] = useState(0);
  const audioContextRef = useRef(null);
  const audioBufferRef = useRef(null);
  const sfxBaseNote = 70; // B♭ major corresponds to the MIDI note number 70

  useEffect(() => {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    audioContextRef.current = audioContext;

    fetch(sfxToot)
      .then(response => response.arrayBuffer())
      .then(arrayBuffer => audioContext.decodeAudioData(arrayBuffer))
      .then(audioBuffer => {
        audioBufferRef.current = audioBuffer;
      });

    return () => {
      audioContext.close();
    };
  }, []);

  const playNote = () => {
    if (audioContextRef.current && audioBufferRef.current) {
      const source = audioContextRef.current.createBufferSource();
      source.buffer = audioBufferRef.current;
      source.connect(audioContextRef.current.destination);
	  
	  // next
      const midiNote = songNotes[currentNoteIndex];
      const playbackRate = Math.pow(2, (midiNote - sfxBaseNote) / 12);
      source.playbackRate.value = playbackRate;
      setCurrentNoteIndex((currentNoteIndex + 1) % songNotes.length);
	  
      source.start(0);
    }
  };

  const images = [
    imgCritter1, imgCritter2, imgCritter3, imgCritter4,
    imgCritter5, imgCritter6, imgCritter7, imgCritter8,
    imgCritter9, imgCritter10, imgCritter11, imgCritter12,
    imgCritter13, imgCritter14, imgCritter15, imgCritter16
  ];

  return (
    <ImageGrid>
      {images.map((src, index) => (
        <AnimatedImageComponent key={index} src={src} alt={`${index + 1}`} playNote={playNote} />
      ))}
    </ImageGrid>
  );
}


function SectionCollection() {
	return (
		<>
		<StyledTable>
			<tbody>
			<StyledRow>
					<StyledTitle>Artist:</StyledTitle>
					<StyledValue><a href={links.twitterGoop} target="_blank">goopgoop_art</a></StyledValue>
				</StyledRow>

				{/*<StyledRow>
					<StyledTitle>Mint Date:</StyledTitle>
					<StyledValue>Jan 27, 2025 (<em><a href="https://x.com/dailofrog/status/1882998291388154306" target="_blank">mainnet launch</a></em>)</StyledValue>
				</StyledRow>*/}

				<StyledRow>
					<StyledTitle>Network:</StyledTitle>
					{/*<StyledValue><a href={links.abstract} target="_blank">{chain.name}</a></StyledValue>*/}
					<StyledValue><a href={links.abstract} target="_blank">Abstract</a></StyledValue>
				</StyledRow>
				<StyledRow>
					<StyledTitle>Supply:</StyledTitle>
					<StyledValue>{data.totalSupply}</StyledValue>
				</StyledRow>
				
				{/*
				 <StyledRow>
					<StyledTitle>Mint Price:</StyledTitle>
					<StyledValue>{data.pricePublic}Ξ ({data.priceWhitelist}Ξ WL)</StyledValue>
				</StyledRow> 
				*/}
				<StyledRow>
					<StyledTitle>Storage:</StyledTitle>
					<StyledValue>✔️ <a href="https://onchainchecker.xyz/collection/abstract/0xb47a26df28923bc826100256e7d5fa01cd0817a7/420" target="_blank">100% fully onchain</a></StyledValue>
				</StyledRow>
				<StyledRow>
					<StyledTitle>Media:</StyledTitle>
					<StyledValue>Interactive HTML &amp; SVG</StyledValue>
				</StyledRow>
				<StyledRow>
					<StyledTitle>Token:</StyledTitle>
					<StyledValue>ERC-721</StyledValue>
				</StyledRow>
				<StyledRow>
					<StyledTitle>Provenance:</StyledTitle>
					<StyledValue>1st PFP on Abstract (<a href="https://abscan.org/tx/0x18e8276609839ef229b10a4ce180d06d29e3e54377a259431a08681c6edecf15" target="_blank">deployed Jan 25</a>)</StyledValue>
				</StyledRow>
				
				{!data.hidden && <StyledRow>
					<StyledTitle>Contract:</StyledTitle>
					<StyledValue><a href={links.contractFrontEnd} target="_blank">{abbreviateAddress(process.env.REACT_APP_CONTRACT_ERC721,5)}</a></StyledValue>
				</StyledRow>}
				{/* <StyledRow>
					<StyledTitle>Num Possible Variations:</StyledTitle>
					<StyledValue>{data.numVariations.toLocaleString()}</StyledValue>
				</StyledRow> */}
				{/*<StyledRow>
					<StyledTitle>Color Palette:</StyledTitle>
					<StyledValue>NES (8-bit)</StyledValue>
				</StyledRow>*/}
				<StyledRow>
					<StyledTitle>Roadmap:</StyledTitle>
					<StyledValue>No roadmap/utility, just derps</StyledValue>
				</StyledRow>
				{/* <StyledRow>
					<StyledTitle>Marketplace:</StyledTitle>
					<StyledValue><a href={links.opensea} target="_blank">OpenSea</a>, <a href={links.elementStore} target="_blank">Element</a>, <a href={links.blur} target="_blank">Blur</a></StyledValue>
				</StyledRow> */}
			</tbody>
		</StyledTable>

		
		<Style.FooterText>
		<em>© {new Date().getFullYear()} dailofrog technologies. all rights reserved.</em>
				</Style.FooterText>
		</>
	)
}

function SectionWhitelist() {

	const [address, setAddress] = useState("");
	const [isAddressValid, setIsAddressValid] = useState();

	const handleInputChange = (event) => {
		console.log(event.target.value);
		setAddress(event.target.value);
	};

	useEffect(()=>{
		setIsAddressValid(containsAddressInList(address));
	}, [address]);

	return (
		<>
			<p><strong>whitelists openned Jan 27th right whenever Abstract mainnet officially goes live. whitelist phase will be running for ~4 hours prior to public mint phase.</strong></p>
			<br/>
			<p>
				whitelists are provided to the esteemed token holders of <a href={links.linktree} target="_blank">dailofrog's work</a>, specfically for collections:
			</p>

			<br/>
			<p>
				<em>tiny based frogs, krakrocks, blastrocks, community gardens, and pepe journey</em>
			</p>
{/*
			<br/>

			<p>if you are a holder of other our non-EVM collections (i.e. Kibodo Kitty Club or Memory Blocks) and would like WL, please DM me directly <a href={links.twitter} target="_blank">@dailofrog</a>.</p>

			
				<>
				<br/>
				<p>whitelist checker:</p>
				<input type="text" style={{ width: "100%", padding: "0.5em", fontFamily:"monospace" }} placeholder="Your address (0x...)" onChange={handleInputChange} />
				{address != "" && <p>{isAddressValid? `✔️ ${abbreviateAddress(address)} is whitelisted!`:`❌ Address not whitelisted`}</p>}
				</>
			*/}
		</>
	)
}

function SectionTech() {

	return (
		<>


			<p>▪ <strong>Interactive HTML &amp; SVG</strong></p>
			<p>You can click on your derplets, they are a bit gassy tho. We developed custom onchain technology to showcase each derplet as an interactive HTML element while also offering a static generative SVG for previews. This enables you to interact with your derplet when viewed as a single token while also maintaining a static infinitely-scalable pixel SVG for previews.</p>
		
			<br/>

			<p>▪ <strong>100% Fully Onchain Rendering Engine</strong></p>
			<p>This project exists entirely onchain, with no reliance on third-party storage solutions. We developed custom code that transforms <a href={links.twitterGoop} target="_blank">goopgoop_art's</a> handcrafted pixels into Solidity bytecode, ensuring the artwork is fully inscribed within the contract itself. As a result, all image layers are stored permanently onchain to generate a shitton of possible derplet variations.</p>

			<br/>

			<p>(<a href="https://x.com/dailofrog/status/1879341841801437310" target="_blank">Read more about the tech</a>)</p>
			</>
	)
}


function SectionProvenance() {

	return (
		<>
			<p>Derplets contracts was deployed on Jan 25th on <a href="https://api.abscan.org/api?module=logs&action=getLogs&fromBlock=0&toBlock=999999999999&topic0=0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef&topic3=0x0000000000000000000000000000000000000000000000000000000000000002&topic0_3_opr=and&offset=1000&apikey=YourApiKeyToken" target="_blank">block 206939</a> via the leaked mainnet RPC, which was few days prior to Abstract's mainnet launch (Jan 27th). Derplets are the first PFP NFT collection deployed on the network. </p>
			<br/>
			<p>(<a href="https://abscan.org/tx/0x18e8276609839ef229b10a4ce180d06d29e3e54377a259431a08681c6edecf15" target="_blank">Deployment transaction</a>)</p>
			</>
	)
}

function SectionFolders() {
	const { isConnected , address } = useAccount();
	const { disconnect } = useDisconnect();
	const [folder, setFolder] = useState("collection");
	
	return (
		<>
			{isConnected && address && <p style={{fontSize:"0.75em", border:"1px dotted var(--text)", backgroundColor:"#e6ffb2", borderRadius:"5px", padding: "0.75em"}}><em>Tabs hidden during mint, <a style={{color:"red"}} onClick={disconnect}>disconnect wallet</a> to unhide.</em></p>}

			{ !(isConnected && address) &&
				<>
					<FolderHeader>
						<FolderTab onClick={()=>{setFolder("collection")}} active={folder=="collection"?"true":"false"}>info</FolderTab>
						<FolderTab onClick={()=>{setFolder("tech")}} active={folder=="tech"?"true":"false"}>tech</FolderTab>
						{/*<FolderTab onClick={()=>{setFolder("whitelist")}} active={folder=="whitelist"?"true":"false"}>whitelist</FolderTab>*/}
						<FolderTab onClick={()=>{setFolder("provenance")}} active={folder=="provenance"?"true":"false"}>provenance</FolderTab>
					</FolderHeader>
					<hr/>

					<FolderContent>
						{folder=="collection" &&  <SectionCollection/>}
						{/*folder=="whitelist" &&  <SectionWhitelist/>*/}
						{folder=="provenance" &&  <SectionProvenance/>}
						{folder=="tech" &&  <SectionTech/>}
					</FolderContent>
				</>
			}
      				
		</>
	)
}


function SectionHero() {

	const HIDDEN = data.hidden;

	return (
         <Style.Section>
      		<Style.HeroContainer >	

      			<Style.ColumnHeroImage>
      				<div style={{margin:"0 auto"}}>
						<Style.ShowMobile><br/><br/></Style.ShowMobile>
						<ImageGridComponent/>

						<Style.HiddenMobile>
							<p style={{display:"", textAlign:"center", marginTop: "0.25em", opacity:"0.7", fontSize:"0.8em"}}><em>* click me</em></p>
						</Style.HiddenMobile>
      			    {/*<Style.ResponsiveImage draggable="false" src={HIDDEN ? imgSingle : imgHero} />*/}
      			    </div>
      			</Style.ColumnHeroImage>

				  <Style.ShowMobile><br/></Style.ShowMobile>

				{(
      			<Style.ColumnHeroDesc>
      			   <h1>derplets</h1>
               		<p style={{fontSize:"1.3em"}}>by <a href={links.twitter} target="_blank">dailofrog</a></p>
      			   <br/>
				   <Style.ShowMobile><br/></Style.ShowMobile>
      				<p style={{fontSize:"1.4em"}}>100% fully onchain pet pals and first PFP collection on <a href={links.abstract} target="_blank">Abstract</a>. These litto interactive frens are speshul &amp; full of heart. ❤️</p>

					<br/>
					<br/>
					<Mint/>
							
					<br/>
					<SectionFolders/>
			  	
      			</Style.ColumnHeroDesc>
				)}
      		</Style.HeroContainer>
       
         </Style.Section>)
}

function FrontPage() {
  return (
      <>
        <SectionHero/>
      </>
  );
}

export default FrontPage;
